export var ActivityType;
(function (ActivityType) {
    /**
     * 新會員加碼
     */
    ActivityType["NEW_MEMBER_BONUS"] = "new_member_bonus";
    /**
     * 推薦好友
     */
    ActivityType["RECOMMEND_FRIEND"] = "recommend_friend";
    /**
     * 邀請好友
     */
    ActivityType["INVITE_FRIEND"] = "invite_friend";
    /**
     * 升級禮金
     */
    ActivityType["UPGRADE_BONUS_GOLD"] = "upgrade_bonus";
    /**
     * 晉級福利（升級禮金、每週紅包、生日禮金）
     */
    ActivityType["RANK_BONUS"] = "rank_bonus";
    /**
     * 每日簽到
     */
    ActivityType["DAILY_SIGN_IN_BONUS"] = "daily_sign_in";
    /**
     * 高額返水
     */
    ActivityType["HIGH_CASH_BACK"] = "9";
    /**
     * 存送紅包
     */
    ActivityType["WEEKLY_BONUS_GOLD"] = "weekly_bonus";
    /**
     * 生日禮金
     */
    ActivityType["BIRTHDAY_BONUS_GOLD"] = "birthday_bonus";
    /**
     * 輪播圖
     */
    ActivityType["BANNER"] = "banner";
    /**
     * 靜態活動
     */
    ActivityType["LAYOUT"] = "layout";
    /**
     * 新年 2023 金兔新春抽红包
    */
    ActivityType["NEW_YEAR_2023"] = "new_year_2023";
    /**
     * 端午開粽領彩金
     */
    ActivityType["DRAGON_BOAT_FESTIVAL_2023"] = "dragon-boat-festival-2023";
    /**
     * 新年 2024 祥龍新春抽紅包
     */
    ActivityType["NEW_YEAR_2024"] = "new_year_2024";
    /**
     * 新年 2025 蛇年旺鴻運 活動管理
     */
    ActivityType["NEW_YEAR_2025_SNAKE_YEAR_GOOD_LUCK"] = "snake_year_good_luck";
    /**
     * 新年 2025 蛇年旺鴻運 金蛇送福抽大奖
     */
    ActivityType["NEW_YEAR_2025_DRAW"] = "snake_year_good_luck_draw";
    /**
     * 新年 2025 蛇年旺鴻運 集蛇卡闹元宵
     */
    ActivityType["NEW_YEAR_2025_RED_ENVELOPE"] = "snake_year_good_luck_red_envelope";
    /**
     * 新年 2026 马年豪礼奔腾 金马年转好运 活動管理
     */
    ActivityType["NEW_YEAR_2026"] = "new_year_2026";
    /**
     * 新年 2026 马年豪礼奔腾 金马年转好运 抽大奖
     */
    ActivityType["NEW_YEAR_2026_TICKET"] = "new_year_2026_ticket";
    /**
     * 新年 2026 马年豪礼奔腾 金马年转好运 紅包
     */
    ActivityType["NEW_YEAR_2026_RED_ENVELOPE"] = "new_year_2026_red_envelope";
    /**
     * 大笔存纵横全场
     */
    ActivityType["DEPOSIT_BONUS"] = "deposit_bonus_2024";
    /**
     * 趁胜追击战欧场
     */
    ActivityType["UEFA_BUILDING_UP"] = "uefa_building_up";
    /**
     * 众星角逐争荣耀
     */
    ActivityType["UEFA_STARS"] = "uefa_stars";
    /**
     * 大奖周周抽
     */
    ActivityType["WEEKLY_BONUS_DRAW"] = "weekly_bonus_draw";
    /**
     * 大奖天天抽
     */
    ActivityType["DAILY_BONUS_DRAW"] = "daily_bonus_draw";
})(ActivityType || (ActivityType = {}));
//# sourceMappingURL=ActivityType.js.map